// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nfieldset[data-v-26046d79] {\n  border-color: var(--v-subtle-base);\n  border-radius: 5px;\n  /* margin-bottom: 12px; */\n  padding-left: 4px;\n}\nlegend[data-v-26046d79] {\n  padding: 0 8px;\n}\n", ""]);
// Exports
module.exports = exports;
